import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  name: FelaCSS;
  priceWrapper: FelaCSS;
  from: FelaCSS;
  price: FelaCSS;
  description: FelaCSS;
  showMore: FelaCSS;
  whatsIncluded: FelaCSS;
  includedItems: FelaCSS;
  includedItem: FelaCSS;
}

const styles = ({ order }: { order: number }): IStyles => ({
  wrapper: {
    borderWidth: order === 1 ? 2 : 1,
    borderStyle: 'solid',
    borderColor: order === 0 ? colors.teal120 : colors.space15,
    borderRadius: 8,
  },
  name: {
    fontDefault: 20,
    lineHeight: '130%',
    wordBreak: 'break-word',
  },
  priceWrapper: {
    alignItems: 'baseline',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 4,
  },
  from: {
    fontDefault: 14,
    lineHeight: '100%',
    color: colors.space60,
  },
  price: {
    fontDefaultSemiBold: 20,
    lineHeight: '130%',
  },
  description: {
    fontDefault: 16,
    lineHeight: '150%',
    color: colors.space60,
    paddingTop: 2,
    wordBreak: 'break-word',
  },
  showMore: {
    alignItems: 'flex-start',
    paddingTop: 4,
  },
  whatsIncluded: {
    fontDefaultSemiBold: 16,
    lineHeight: '150%',
    paddingBottom: 4,
  },
  includedItems: {
    gap: 12,
    desktopDesign: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 50%)',
    },
  },
  includedItem: {
    fontDefault: 16,
    lineHeight: '150%',
    color: colors.space75,
    alignItems: 'baseline',
    wordBreak: 'break-word',
    flexWrap: 'wrap',
  },
});

export default styles;
